import { render, staticRenderFns } from "./channel-info.vue?vue&type=template&id=bba7ebb2&"
import script from "./channel-info.vue?vue&type=script&lang=js&"
export * from "./channel-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports